import type { FeatureConfigMap } from '@luna/feature-config';

import type { WatchdogsFeatureConfig } from './type';
import { watchdogs as base } from './base';
import { watchdogs as AT } from './AT';
import { watchdogs as CZ } from './CZ';
import { watchdogs as HR } from './HR';
import { watchdogs as HU } from './HU';
import { watchdogs as RO } from './RO';

export const featureConfigMap: FeatureConfigMap<WatchdogsFeatureConfig> = {
    base,
    AT,
    CZ,
    HR,
    HU,
    RO,
};
